var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1438_363603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM10.21 19.667C9.22341 17.5743 8.65187 15.3102 8.527 13H4.562C4.75659 14.5389 5.39392 15.9882 6.39657 17.1717C7.39922 18.3552 8.72401 19.2221 10.21 19.667ZM10.53 13C10.681 15.439 11.378 17.73 12.5 19.752C13.6523 17.6766 14.3254 15.3695 14.47 13H10.53ZM20.438 13H16.473C16.3481 15.3102 15.7766 17.5743 14.79 19.667C16.276 19.2221 17.6008 18.3552 18.6034 17.1717C19.6061 15.9882 20.2434 14.5389 20.438 13ZM4.562 11H8.527C8.65187 8.68979 9.22341 6.42569 10.21 4.333C8.72401 4.77788 7.39922 5.64475 6.39657 6.8283C5.39392 8.01184 4.75659 9.4611 4.562 11ZM10.531 11H14.469C14.3248 8.6306 13.652 6.32353 12.5 4.248C11.3477 6.32345 10.6746 8.63052 10.53 11H10.531ZM14.79 4.333C15.7766 6.42569 16.3481 8.68979 16.473 11H20.438C20.2434 9.4611 19.6061 8.01184 18.6034 6.8283C17.6008 5.64475 16.276 4.77788 14.79 4.333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1438_363603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslator);
export default __webpack_public_path__ + "static/media/translator.a9a4209712d0b4316a1f100f62e821a6.svg";
export { ForwardRef as ReactComponent };